export default "__VITE_ASSET__HJB4OCbM__"